import { render, staticRenderFns } from "./generalSuicidalAlert.vue?vue&type=template&id=98b92cba"
import script from "./generalSuicidalAlert.vue?vue&type=script&lang=js"
export * from "./generalSuicidalAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports